const INDIA_TIMEZONES = ['Asia/Kolkata', 'Asia/Calcutta'];

/**
 * @returns {boolean}
 */
function isIndiaTimezone() {
  return INDIA_TIMEZONES.includes(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );
}

/**
 * @param {boolean} showFastrr
 */
function applyCheckoutVisibility(showFastrr) {
  const css = showFastrr
    ? `
      button[name="checkout"],
      .buy-now-button,
      .shopify-payment-button,
      .shopify-payment-button__button.shopify-payment-button__button--unbranded {
        display: none !important;
      }
    `
    : `
      .shiprocket-headless {
        display: none !important;
      }
    `;

  const styleElement = document.createElement('style');
  styleElement.textContent = css;
  document.head.appendChild(styleElement);
}

function initFastrrCheckoutVisibility() {
  const root = document.querySelector('.fastrr-checkout');
  if (!(root instanceof HTMLElement)) {
    return;
  }

  const indiaOnly = root.dataset.indiaOnly === 'true';
  const showFastrr = indiaOnly ? isIndiaTimezone() : true;
  applyCheckoutVisibility(showFastrr);
}

initFastrrCheckoutVisibility();
